import { useEffect } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { HOTELS_PATH, useDeviceType } from "@b2bportal/core-utilities";

import { HotelSearch } from "@tenant/hotels";
import { Page } from "@tenant/ui";
import clsx from "clsx";

import defaultStyles from "./SearchPage.module.scss";

export type SearchPageComponentProps = PlatformComponentProps;

export const SearchPage = ({
  className,
  children,
}: SearchPageComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.SearchPage;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { isDesktopAndUp } = useDeviceType();
  const navigate = useNavigate();

  useEffect(() => {
    if (isDesktopAndUp) {
      // Push to homepage hotel search
      navigate(HOTELS_PATH, { replace: true });
    }
  }, [isDesktopAndUp]);

  return (
    <Page className={clsx(block, className)}>
      <div className={cn("container")}>
        <div className={cn("content")}>
          <HotelSearch />
          {children}
        </div>
      </div>
    </Page>
  );
};
